import React from "react";
import { Button, Spinner } from "react-bootstrap";

interface SubmitButtonProps {
  isSubmitting: boolean;
  isEdit?: boolean;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  labels?: {
    create?: string;
    update?: string;
    submitting?: string;
    updating?: string;
  };
  className?: string;
  style?: React.CSSProperties;
  disabled?: boolean;
}

const SubmitButton: React.FC<SubmitButtonProps> = ({
  isSubmitting,
  isEdit,
  onClick,
  labels,
  className = "",
  style,
  disabled,
}) => {
  const {
    create = "Add",
    update = "Update",
    submitting = "Adding...",
    updating = "Updating...",
  } = labels || {};

  const themeColor = '#3969E7'; // Primary color from tableStyles

  const buttonStyle: React.CSSProperties = {
    backgroundColor: themeColor,
    borderColor: themeColor,
    color: '#fff',
    ...style,
  };

  const buttonClassName = `w-sm-auto py-2 px-3 ${className} custom-color-button`;

  return (
    <>
      <style>
        {`
          .custom-color-button:hover {
            background-color: ${themeColor} !important;
            border-color: ${themeColor} !important;
            opacity: 0.9;
          }
          .custom-color-button:focus {
            background-color: ${themeColor} !important;
            border-color: ${themeColor} !important;
            box-shadow: 0 0 0 0.2rem ${themeColor}40 !important;
          }
          .custom-color-button:disabled {
            background-color: ${themeColor} !important;
            border-color: ${themeColor} !important;
            opacity: 0.6;
          }
        `}
      </style>
      <Button
        type={onClick ? "button" : "submit"}
        variant={undefined}
        disabled={disabled || isSubmitting}
        onClick={onClick}
        className={buttonClassName}
        style={buttonStyle}
      >
      {isSubmitting ? (
        <>
          <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
            className="me-2"
          />
          {isEdit ? updating : submitting}
        </>
      ) : isEdit ? (
        update
      ) : (
        create
      )}
    </Button>
    </>
  );
};

export default SubmitButton;
